import { createAction, createReducer, PayloadAction } from '@reduxjs/toolkit';
import { PromocodeInfo } from 'reactApp/api/promo/PromocodeGetAPICall';
import { State } from 'reactApp/modules/promocode/promocode.types';

const initialState: State = {
    isLoading: false,
    isLoaded: false,
    promocodes: [],
};

export const loadPromocodes = createAction('promocodes/loadRequest');
export const loadPromocodesSuccess = createAction<PromocodeInfo[]>('promocodes/loadSuccess');

export const promocodesReducer = createReducer(initialState, {
    [loadPromocodes.type]: (state) => {
        state.isLoading = true;
        state.isLoaded = false;
    },
    [loadPromocodesSuccess.type]: (state, action: PayloadAction<PromocodeInfo[]>) => {
        state.isLoading = false;
        state.isLoaded = true;
        state.promocodes = action.payload;
    },
});
